import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import * as _ from "lodash";

import styles from './style.css';
import Icon from "../../../../icons/Icon";
import UiIcon from "../../../../uq-ui/components/ui-icon";
import { currentUserInfoSelector } from 'src/app/modules/auth/store/auth-user/selectors';
import { setSidebarVisibility } from '../../../../layout/store/actions';
import { getTranslationLang } from '../../../../../i18n';

class LayoutComponentsHeader extends PureComponent {

  static propTypes = {
    onBack: PropTypes.func,
    showGreeting: PropTypes.bool,
    showBackBtn: PropTypes.bool,
    showLogo: PropTypes.bool,
    theme: PropTypes.string
  };

  static defaultProps = {
    onBack: () => {},
    showLogo: false,
    showBackBtn: false,
    showGreeting: false,
    onShowSidebar: () => {},
    theme: 'dark'
  };

  onBackPressed = () => {
    this.props.onBack();
  };

  onHamburgerPressed = () => {
    this.props.setSidebarVisibility(true);
  }

  renderGreetingText() {
    let greetingText = '';
    if (!_.isEmpty(this.props.currentUserInfo)) {
      const { display_name } = this.props.currentUserInfo;
      if (display_name) {
        greetingText = `${this.props.t('withName')} ${display_name}!`;
      } else {
        greetingText = this.props.t('withoutName');
      }
    } else {
      greetingText = this.props.t('anonymous');
    }
    return (<div className={`${styles.headerText} font-title`}>{greetingText}</div>);
  }

  render() {
    const { theme, showGreeting, showLogo } = this.props;
    // The bar is the page color (like the sticker page), so its controls are
    // dark in the base theme and light in the memorial theme. `theme` is
    // accepted for older callers and no longer changes anything.
    const humburgerStyle = getTranslationLang() === 'en' ? {position: 'absolute', right: '14px'} : {position: 'absolute', left: '14px'}
    const hamburgerProps = { style: showGreeting ? {} : humburgerStyle, onClick: this.onHamburgerPressed };
    return (
      <div className={styles.header}
           style={{ justifyContent: showLogo ? 'center' : 'space-between'}}>
        { this.props.showBackBtn && (
          <button type="button"
                  onClick={this.onBackPressed}
                  className={styles.headerBackBtn}>
            <UiIcon name="back" size={24} rtl={true} color="var(--c-icon)"/>
          </button>
        ) }
        {
          showGreeting && 
          <div style={{ alignItems: 'center', display: 'flex' }}>
            <Icon name="DefaultAvatar" width="34px" height="34px"/>
            { this.renderGreetingText() }
          </div>
        }
        {
          showLogo && <Fragment>
            <Icon name="LogoDark" className="theme-base-only"/>
            <Icon name="LogoWhite" className="theme-memorial-only"/>
          </Fragment>
        }
        <div></div>
        <UiIcon name="menu" size={26} color="var(--c-icon)" {...hamburgerProps}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUserInfo: currentUserInfoSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSidebarVisibility: (visible) => dispatch(setSidebarVisibility(visible)),
  }
};

export default compose(
  withTranslation('cmp-header'),
  connect(mapStateToProps, mapDispatchToProps)
)(LayoutComponentsHeader);